module.exports = __webpack_public_path__ + "img/008.fa21e166.png";